module.exports = __webpack_public_path__ + "img/bg_image_2.00bccf98.png";